import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classnames from 'classnames';
import React from 'react';
import { includes } from 'lodash';
import styles from './cta.scss';
import ArrowRightLongIcon from '../../../../../../icons/compiled/components/ArrowRightLongIcon';
import TriangleIcon from '../../../../../../icons/compiled/components/TriangleIcon';
import { TwitterButton } from '../../social-buttons/twitter';
import { YoutubeButton } from '../../social-buttons/youtube';
import { FacebookButton } from '../../social-buttons/facebook';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import { InlineIcon } from '../../../../../inline-icon/inline-icon';
export class CardCTA extends React.Component {
  renderSocialButton() {
    const {
      cardData,
      labels,
      isAccessible
    } = this.props;
    const {
      facebookButtonTitle,
      youtubeButtonTitle,
      twitterButtonTitle
    } = labels;
    switch (cardData.network) {
      case 'twitter':
        return /*#__PURE__*/React.createElement(TwitterButton, {
          isAccessible: isAccessible,
          twitterButtonTitle: twitterButtonTitle,
          cardData: cardData
        });
      case 'youtube':
        return /*#__PURE__*/React.createElement(YoutubeButton, {
          isAccessible: isAccessible,
          youtubeButtonTitle: youtubeButtonTitle,
          cardData: cardData
        });
      case 'facebook':
        return /*#__PURE__*/React.createElement(FacebookButton, {
          isAccessible: isAccessible,
          facebookButtonTitle: facebookButtonTitle,
          cardData: cardData
        });
      default:
        return null;
    }
  }
  isLiveVideo() {
    const {
      itemType
    } = this.props.cardData;
    return itemType === ItemType.ItemLive;
  }
  renderDefaultCTA() {
    const {
      type,
      buttonLabel
    } = this.props.cardData;
    const isArrowIcon = includes([VIDEO_CARD_TYPES.CUSTOM, VIDEO_CARD_TYPES.PRODUCT], type);
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.label,
      "data-hook": "action-card-action-text"
    }, this.isLiveVideo() && /*#__PURE__*/React.createElement("div", {
      className: styles.circle
    }), buttonLabel), /*#__PURE__*/React.createElement("div", {
      className: styles.icon
    }, isArrowIcon ? /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(ArrowRightLongIcon, null),
      className: styles['icon-arrow']
    }) : /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(TriangleIcon, null),
      className: styles['icon-play']
    })));
  }
  render() {
    return this.props.cardData.type === VIDEO_CARD_TYPES.SOCIAL ? /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.container, styles['with-social-button']),
      "data-hook": "action-card-action-text"
    }, this.renderSocialButton()) : this.renderDefaultCTA();
  }
}
_defineProperty(CardCTA, "defaultProps", {
  labels: {}
});
//# sourceMappingURL=cta.js.map